module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-individual-4cd01daadba1064162678016e93a31b8.webp";